import { pixiesetURLs } from "./pixieset-urls"

export const POLARR_NEXT_DOWNLOAD_URL = "https://next.polarr.com/download"

export const getDesktopAppDownloadUrl = (isPixiesetAuthEnabled: boolean): string => {
	return isPixiesetAuthEnabled ? pixiesetURLs.root.photoEditorDownload : POLARR_NEXT_DOWNLOAD_URL
}
